import Joi from 'joi';
const inspirationHeaderBlockSchema = Joi.object({
  type: Joi.string().valid('inspirationHeaderBlock').required(),
  code: Joi.string().allow('', null).required(),
  bottomPosition: Joi.string().allow('', null).required(),
  background: Joi.string().allow('', null).required(),
  title: Joi.string().allow('', null).required(),
  titleColor: Joi.string().allow('', null).required(),
  subtitle: Joi.string().allow('', null).required(),
  subtitleColor: Joi.string().allow('', null).required()
}).unknown(true);
export default inspirationHeaderBlockSchema;